"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compressImage = compressImage;
exports.computePasswordLevel = computePasswordLevel;
exports.computePasswordStrength = computePasswordStrength;
exports.convertRemToPixels = convertRemToPixels;
exports.formatSize = formatSize;
exports.generateColorHex = generateColorHex;
exports.getAttachmentContentType = getAttachmentContentType;
exports.getAttachmentType = getAttachmentType;
exports.getComputedStyle = getComputedStyle;
exports.getScrollParent = getScrollParent;
exports.getSignatureImages = getSignatureImages;
exports.isAlphaNum = isAlphaNum;
exports.isEmail = isEmail;
exports.isImage = isImage;
exports.isInlineImage = isInlineImage;
exports.isPdf = isPdf;
exports.isURL = isURL;
exports.queryDarkTheme = queryDarkTheme;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _zxcvbn = _interopRequireDefault(require("zxcvbn"));
var _chromaJs = _interopRequireDefault(require("chroma-js"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _get = _interopRequireDefault(require("lodash/get"));
var _toPairs = _interopRequireDefault(require("lodash/toPairs"));
var _numeral = _interopRequireDefault(require("numeral"));
var yup = _interopRequireWildcard(require("yup"));
var _mimeTypes = _interopRequireDefault(require("mime-types"));
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Generate color hash
 *
 * @public
 * @param {string} seed - Referenced string
 * @returns {string}
 */
function generateColorHex(seed) {
  if (!(0, _isNil["default"])(seed)) {
    return '#' + (seed.split('').reduce(function (prev, curr) {
      var a = (prev << 5) - prev + curr.charCodeAt(0);
      return a & a;
    }, 0) * 0xffffff << 0).toString(16).slice(-6);
  } else return _chromaJs["default"].random().hex();
}
var emailSchema = yup.string().email();
var urlSchema = yup.string().url();
/**
 * Return true or false for validated email address or not
 *
 * @public
 * @param {string} input - The input string
 * @returns {boolean}
 */
function isEmail(input) {
  return emailSchema.isValidSync(input);
}
/**
 * Return true or false for validated url or not
 *
 * @public
 * @param {string} input - The input string
 * @returns {boolean}
 */
function isURL(input) {
  if ((input || '').trim().length === 0) return false;
  return urlSchema.isValidSync(input) || input.startsWith('mailto:');
}

/**
 * Compress to input image
 *
 * @public
 * @param {File} image - The image to compress
 * @param {Object} size - Width and height after compressed
 * @returns {Promise<string>}
 */
function compressImage(image) {
  var other = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _other$height = other.height,
    height = _other$height === void 0 ? 64 : _other$height,
    _other$width = other.width,
    width = _other$width === void 0 ? 64 : _other$width,
    _other$mimeType = other.mimeType,
    mimeType = _other$mimeType === void 0 ? 'image/png' : _other$mimeType;
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      var image = new Image();
      image.src = reader.result.toString();
      image.onload = function () {
        var canvas = document.createElement('canvas');
        var canvastx = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        var ratio = 1;
        var sx = 0,
          sy = 0;
        if (image.width / image.height < width / height) {
          ratio = width / image.width;
          sy = Math.abs(height - image.height * ratio) / 2;
        } else {
          ratio = height / image.height;
          sx = Math.abs(width - image.width * ratio) / 2;
        }
        canvastx.drawImage(image, sx / ratio, sy / ratio, image.width - sx * 2 / ratio, image.height - sy * 2 / ratio, 0, 0, canvas.width, canvas.height);
        var dataURL = canvas.toDataURL(mimeType);
        resolve(dataURL);
      };
    };
    reader.readAsDataURL(image);
  });
}

/**
 * Computes password strength.
 *
 * @public
 * @param {string} password - password string to compute strength for
 * @returns {number}
 */
function computePasswordStrength(password) {
  try {
    return (0, _zxcvbn["default"])(password).score;
  } catch (e) {
    return 0;
  }
}

/**
 * Returns the password security level
 *
 * @public
 * @param {string} password - password string to compute
 * @returns {PasswordLevel}
 */
function computePasswordLevel(password) {
  var score = computePasswordStrength(password);
  if (score > 3) {
    return _constants.passwordLevel.STRONG;
  } else if (score > 1 && score < 4) {
    return _constants.passwordLevel.FAIR;
  } else {
    return _constants.passwordLevel.WEAK;
  }
}

/**
 * get computed style in tailwind config
 * @param {*} variant
 * @param {*} _default
 */
function getComputedStyle(variant, _default) {
  var key = /var\(([\w-]+)\)/.exec(variant);
  if (key) {
    return window.getComputedStyle(document.documentElement).getPropertyValue((0, _get["default"])(key, '1', '')).trim();
  }
  return _default;
}

// Used for converting from rem to pixels to pass into iframes
function convertRemToPixels(rem) {
  return rem * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
}

/**
 * Returns if a string is alphanumeric .
 *
 * @public
 * @param str
 * @returns {boolean} - true if string is alphanumeric
 */
function isAlphaNum(s) {
  var code, i, len;
  for (i = 0, len = s.length; i < len; i++) {
    code = s.charCodeAt(i);
    if (!(code > 47 && code < 58) &&
    // upper alpha (A-Z)
    !(code > 64 && code < 91) &&
    // upper alpha (A-Z)
    !(code > 96 && code < 123) // lower alpha (a-z)
    ) {
      return false;
    }
  }
  return true;
}
function getAttachmentContentType(contentType, fileName) {
  if (contentType && contentType !== _constants.UNKOWN_ATTACHMENT_TYPE) return contentType;
  return _mimeTypes["default"].lookup(fileName) || '';
}
function getAttachmentType(contentType, fileName) {
  var realContentType = getAttachmentContentType(contentType, fileName);
  if (realContentType) {
    var _iterator = _createForOfIteratorHelper((0, _toPairs["default"])(_constants.attachmentCategoryMap)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
          type = _step$value[0],
          extensions = _step$value[1].extensions;
        if (extensions.includes(realContentType)) {
          return type;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return 'other';
}
function isImage(contentType, fileName) {
  var realContentType = getAttachmentContentType(contentType, fileName);
  return (0, _get["default"])(_constants.attachmentCategoryMap, 'image.extensions', []).includes(realContentType);
}
function isInlineImage(contentType, fileName) {
  var realContentType = getAttachmentContentType(contentType, fileName);
  return ['image/bmp', 'image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'].includes(realContentType);
}
function isPdf(contentType, fileName) {
  var realContentType = getAttachmentContentType(contentType, fileName);
  return realContentType === 'application/pdf';
}
function formatSize(bytes) {
  var formatted = (0, _numeral["default"])(bytes).format('0ib').replace('i', '');
  return formatted;
}
function queryDarkTheme() {
  if (window.matchMedia) {
    var media = window.matchMedia('(prefers-color-scheme: dark)');
    return media.matches;
  } else return false;
}
function getScrollParent(node) {
  if (node == null) {
    return null;
  }
  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}
function getSignatureImages(html) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');
  var signatureImageNodes = doc.querySelectorAll('img[src]');
  var imageIds = (0, _toConsumableArray2["default"])(signatureImageNodes).map(function (item) {
    var src = item.getAttribute('src');
    var matchResult = src.match(_constants.SIGNATURE_LINK_REGEXP);
    if (matchResult) {
      return matchResult.groups.imageId;
    }
    return '';
  }).filter(Boolean);
  return (0, _toConsumableArray2["default"])(new Set(imageIds));
}
//# sourceMappingURL=index.js.map